<template>
    <footer class="footer">
      <div class="container text-center">
        <span>WASPL © Copyright Wiquid 2025</span>
      </div>
    </footer>
  </template>
  
  <style scoped>
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: black;
    color: white;
    text-align: center;
    padding: 10px 0;
    z-index: 9999;
  }
  </style>
  